import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import { observer, inject } from 'mobx-react'
import * as styles from './style/index.scss'
import TabBar from './cmp/tabbar'
import DataPlanItem from './cmp/dataPlanItem'
import { WhiteSpace } from 'antd-mobile'
import { decorateTpMth, deepClone } from '@src/utils';
import NoInfo from '@componentsG/noInfo'

@inject('packageStore')
@observer
class MyDataPlan extends ComponentExt<any, any> {
    private store: any
    private readonly userInfo: any = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}

    constructor(props) {
        super(props)
        this.store = props.packageStore
        this.state = {
            current: '0'
        }
    }

    async componentDidMount() {
        this.showLoading()
        await this.store.getPackageList({
            apiName: 'queryUsePlan',
            iccid: this.userInfo.iccid
        })
        this.hideLoading()
    }

    changeTabBar = async value => {
        this.showLoading()
        await this.store.getPackageList({
            apiName: value === '0' ? 'queryUsePlan' : 'queryUserHistoryPlan',
            iccid: this.userInfo.iccid
        })
        this.hideLoading()
        this.setState({
            current: value
        })
    }

    render() {
        const packageList = deepClone(this.store.packageList) || []
        return (
            <div style={{ height: '100%', overflowY: 'scroll' }}>
                <TabBar current={this.state.current} changeTabBar={this.changeTabBar} />
                <WhiteSpace className={styles.whiteSpace} />
                <section className={styles.dataPlanWrap}>
                    {
                        packageList.length === 0 ?
                            <NoInfo
                                messageId={this.state.current === '0' ? 'myDataPlan.noAvailablePlan' : 'myDataPlan.noExpiredPlan'}
                                hasButton={false}
                            />
                            :
                            <>
                                {
                                    packageList.map(item => <DataPlanItem
                                        key={item.goodsReleaseId}
                                        type={this.state.current}
                                        dto={decorateTpMth(item)}
                                    />)
                                }
                            </>
                    }
                </section>
            </div>
        )
    }
}

export default MyDataPlan
